import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AribaSvg = function AribaSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAB900",
    d: "M19.761 18.58 12.731 5h1.555c.308 0 .562.161.683.42L22 19h-1.555a.76.76 0 0 1-.684-.42M6.571 19h1.555a.73.73 0 0 0 .684-.42l1.93-3.703-.998-1.947zm-3.016 0a.73.73 0 0 0 .684-.42L9.714 8.023 15.19 18.58c.127.259.375.42.684.42h1.555l-7.03-13.58A.74.74 0 0 0 9.713 5a.76.76 0 0 0-.683.42L2 19z"
  }));
};
export var Ariba = function Ariba(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AribaSvg
  }));
};